import { registerApp, Priority } from '@mfl/framework';
import { currentUser, PermissionTypes } from '@mfl/platform-shell';
import { navigationItems } from '@mfe/core-navigation';
import strings from './settings-strings';

// Repeating the constants for the puspose of avoiding an additional
// runtime bundle for a `settings-types-BVySIyR3.js` (0.82 kB)
const baseRoute = '/v1/settings';
const DOMAIN_MANAGE = 'domain.manage';

export async function register() {
  // register if user has required permissions
  if (
    currentUser.isAllowedTo(DOMAIN_MANAGE) &&
    currentUser.isAllowedTo(PermissionTypes.domainEdit)
  ) {
    const SETTINGS_KEY = 'SETTINGS';

    await registerApp('settings', baseRoute);
    navigationItems.register(
      {
        key: SETTINGS_KEY,
        text: strings.settings,
        fontAwesomeIcon: 'gear',
        route: baseRoute + '/domain',
      },
      { priority: Priority.Medium - 110 }
    );
  }
}
